export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    export: 'Export',
    exportExcel: 'Export Excel',
    exportJson: 'Export JSON',
    import: 'Import',
    refresh: 'Refresh',
    detail: 'Detail',
    status: 'Status',
    action: 'Action',
    save: 'Save',
    close: 'Close',
    closeOthers: 'Close others',
    closeAll: 'Close all',
    logout: 'Logout',
    logoutConfirm: 'Confirm to log out of the current account?',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit fullscreen',
    collapse: 'Collapse',
    expand: 'Expand',
    submit: 'Submit',
    back: 'Back',
    keyword: 'Keyword',
    total: '{total} in total',
    createTime: 'Created At',
    startTime: 'Start',
    endTime: 'End',
    enable: 'Enable',
    disable: 'Disable',
    batchDelete: 'Batch Delete',
    batchDisable: 'Batch Disable',
    columns: 'Columns',
    density: 'Density',
    exportPage: 'Export current page',
    exportAll: 'Export all',
    success: 'Success',
    failed: 'Failed',
    all: 'All',
    empty: 'No data',
    tips: 'Tips',
    warning: 'Warning',
    retry: 'Retry',
    view: 'View',
    id: 'ID',
    reason: 'Reason',
    result: 'Result',
    select: 'Please select',
    input: 'Please input',
    yes: 'Yes',
    no: 'No',
    copy: 'Copy',
    remark: 'Remark',
    time: 'Time',
    ip: 'IP',
    device: 'Device',
    operator: 'Operator',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    count: 'Count',
    next: 'Next',
    prev: 'Previous',
    download: 'Download',
    upload: 'Upload',
    preview: 'Preview',
    template: 'Template',
    processing: 'Processing…',
    uploadTip: 'Supports {accept}, one file at a time',
    removeFirst: 'Please remove the selected file first',
    parseFailed: 'Parse failed: {message}',
  },
  route: {
    login: 'Login',
    dashboard: 'Dashboard',
    user: 'Users',
    userList: 'User List',
    userDetail: 'User Detail',
    wordbook: 'Wordbooks',
    wordbookList: 'Wordbook List',
    wordbookImport: 'Wordbook Import',
    word: 'Words',
    wordList: 'Word List',
    wordImport: 'Word Import',
    dictionary: 'Dictionaries',
    dictionaryList: 'Dictionary List',
    dictionaryDetail: 'Dictionary Detail',
    review: 'Review',
    reviewTask: 'Review Queue',
    system: 'System',
    systemConfig: 'System Config',
    systemLog: 'Audit Log',
    systemProfile: 'Profile',
    forbidden: 'Forbidden',
    notFound: 'Not Found',
    unknown: 'Untitled',
  },
  login: {
    title: 'WordApp Admin',
    subtitle: 'Welcome back, please sign in',
    username: 'Username',
    usernamePlaceholder: 'Please input username',
    password: 'Password',
    passwordPlaceholder: 'Please input password',
    captcha: 'Captcha',
    captchaPlaceholder: '4 characters',
    remember: 'Remember me (7 days)',
    forgot: 'Forgot password?',
    submit: 'Sign in',
    submitting: 'Signing in…',
    success: 'Signed in',
    contactAdmin: 'Please contact the super administrator to reset your password',
    strength: 'Password strength',
    captchaRefresh: 'Click to refresh captcha',
    captchaFailed: 'Load failed, click to retry',
    defaultPasswordTip: 'You are using the default password, please change it now',
  },
  dashboard: {
    range: 'Range',
    days7: 'Last 7 days',
    days30: 'Last 30 days',
    days90: 'Last 90 days',
    exportPng: 'Export PNG',
    totalUsers: 'Total Users',
    todayNewUsers: 'New Today',
    totalWordbooks: 'Wordbooks',
    totalDictionaries: 'Dictionaries',
    todayActiveUsers: 'Active Today',
    todayLearnedWords: 'Words Learned Today',
    mom: 'MoM',
    userTrend: 'New Users & Learned Words',
    accuracyTrend: 'Average Accuracy',
    languageDist: 'Wordbook Language',
    visibilityDist: 'Private / Public',
    hotWords: 'Hot Words TOP10',
    wordCloud: 'Hot Words Cloud',
    recentLogs: 'Recent Admin Logs',
    abnormalLogins: 'Recent Abnormal Logins',
    newUsers: 'New Users',
    learnedWords: 'Learned Words',
    accuracy: 'Avg Accuracy',
    action: 'Action',
    target: 'Target',
    refreshTip: 'Data refreshes every 60 seconds',
  },
  user: {
    username: 'Username',
    nickname: 'Nickname',
    phone: 'Phone',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    registerTime: 'Registered At',
    lastLogin: 'Last Login',
    searchPlaceholder: 'Username / Nickname / Phone',
    detail: 'User Detail',
    stat: 'Learning Stats',
    loginLogs: 'Login Logs',
    learnDays: 'Learning Days',
    streakDays: 'Streak Days',
    totalLearned: 'Total Learned',
    accuracyRate: 'Accuracy',
    todayLearned: 'Learned Today',
    todayDuration: 'Duration Today',
    dictionaryCount: 'Dictionaries',
    wrongCount: 'Wrong Words',
    disableConfirm: 'Disable this user?',
    disableTip: 'All issued tokens become invalid and the user will be forced offline.',
    enableConfirm: 'Enable this user?',
    deleteConfirm: 'Delete this user?',
    deleteTip: 'Learning records, dictionaries and wrong words will be removed permanently.',
    batchDisableConfirm: 'Disable the selected users?',
    batchDisableTip: '{count} users will be disabled and forced offline.',
    batchDeleteConfirm: 'Delete the selected users?',
    batchDeleteTip: '{count} users and their data will be deleted permanently.',
    resetPwd: 'Reset Password',
    resetPwdTitle: 'Password Reset',
    resetPwdTip: 'The new password is shown only once:',
    changeRole: 'Change Role',
    changeRoleTitle: 'Change User Role',
    selectRole: 'Select role',
    exportUsers: 'Export Users',
  },
  wordbook: {
    name: 'Name',
    description: 'Description',
    cover: 'Cover',
    langFrom: 'From',
    langTo: 'To',
    sortOrder: 'Sort',
    status: 'Status',
    wordCount: 'Words',
    learnCount: 'Learn Count',
    cardView: 'Card View',
    tableView: 'Table View',
    create: 'New Wordbook',
    edit: 'Edit Wordbook',
    relatedWords: 'Words',
    relatedLoadFailed: 'Failed to load, please close and retry',
    addWords: 'Add Existing Words',
    removeWords: 'Remove Selected',
    adjustSort: 'Reorder',
    import: 'Batch Import',
    export: 'Export Wordbooks',
    deleteConfirm: 'Delete this wordbook?',
    deleteTip: 'Dictionaries copied from this wordbook may be affected.',
    offline: 'Take Offline',
    online: 'Publish',
    offlineConfirm: 'Take this wordbook offline?',
    onlineConfirm: 'Publish this wordbook?',
    coverTip: 'Drag & drop an image or fill in an image URL',
  },
  word: {
    headword: 'Headword',
    phonetic: 'Phonetic',
    audio: 'Audio URL',
    partOfSpeech: 'Part of Speech',
    definition: 'Definition',
    example: 'Example',
    exampleTrans: 'Translation',
    difficulty: 'Difficulty',
    etymology: 'Etymology',
    create: 'New Word',
    edit: 'Edit Word',
    inlineEdit: 'Inline Edit',
    references: 'References',
    referencedBy: 'Referenced by {count} wordbooks',
    noReference: 'Not referenced',
    deleteConfirm: 'Delete this word?',
    deleteBlocked: 'This word is still referenced by {count} wordbooks',
    importTip: 'Existing "headword + part of speech" rows are skipped',
    importWordbook: 'Target Wordbook',
    importWordbookPlaceholder: 'Select a wordbook to import into',
    importWordbookRequired: 'Please select a target wordbook first',
    export: 'Export Words',
    detailTitle: 'Word Detail',
  },
  dictionary: {
    name: 'Name',
    owner: 'Owner',
    visibility: 'Visibility',
    sourceType: 'Source',
    wordCount: 'Words',
    subscriberCount: 'Subscribers',
    recommendSort: 'Recommended',
    recommend: 'Recommend',
    recommendTitle: 'Set Recommendation',
    offline: 'Take Offline',
    offlineTitle: 'Take Dictionary Offline',
    offlineReason: 'Reason',
    offlineTip: 'The dictionary becomes private and the owner will be notified.',
    deleteConfirm: 'Delete this dictionary?',
    deleteTip:
      'Impact: {wordCount} words, {subscriberCount} subscribers, {sessionCount} learning records.',
    words: 'Words',
    subscribers: 'Subscribers',
    statTitle: 'Learning Overview',
    learnTimes: 'Learn Times',
    avgAccuracy: 'Avg Accuracy',
    lastLearnAt: 'Last Learned',
    learnerCount: 'Learners',
    export: 'Export Dictionaries',
  },
  review: {
    queue: 'Review Queue',
    user: 'User',
    word: 'Word',
    stage: 'Stage',
    nextReviewAt: 'Next Review',
    lastReviewAt: 'Last Review',
    wrongTimes: 'Wrong Times',
    mastered: 'Mastered',
    trigger: 'Trigger Scan',
    triggerConfirm: 'Trigger review task scan now?',
    triggerTip: 'Scans all due wrong words and generates review tasks.',
    triggerResult: 'Scanned {scanned}, generated {generated} tasks',
    history: 'Review History',
    fromStage: 'From Stage',
    toStage: 'To Stage',
    result: 'Result',
    reviewedAt: 'Reviewed At',
    correct: 'Correct',
    wrong: 'Wrong',
  },
  system: {
    configTitle: 'System Config',
    configKey: 'Key',
    configValue: 'Value',
    description: 'Description',
    valueType: 'Value Type',
    updatedAt: 'Updated At',
    edit: 'Edit Config',
    create: 'New Config',
    editConfirm: 'Update this config?',
    editTip: 'Config changes affect the mobile app behavior.',
    refreshDict: 'Refresh Dictionary',
    logTitle: 'Audit Log',
    action: 'Action',
    targetType: 'Target Type',
    targetId: 'Target ID',
    detailTitle: 'Log Detail',
    beforeSnapshot: 'Before',
    afterSnapshot: 'After',
    profileTitle: 'Profile',
    nickname: 'Nickname',
    phone: 'Phone',
    email: 'Email',
    avatar: 'Avatar',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed, please sign in again',
  },
  error: {
    forbiddenTitle: '403',
    forbiddenDesc: 'You have no permission to access this page',
    notFoundTitle: '404',
    notFoundDesc: 'The page does not exist or has been removed',
    backHome: 'Back Home',
    backLogin: 'Back to Login',
  },
}
